import React from "react";
import { AuthCheck } from "reactfire";
import SignIn from "./SignIn";

export default ({ children }) => (
  <AuthCheck fallback={<SignIn isReauthenticate={true} />}>
    {children}
  </AuthCheck>
);
